import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { openDialog, closeDialog } from '../../actions/dialog';
import { sendResetPasswordEmail } from '../../actions/authentication';
import DialogForm from '../shared/DialogForm';
import SFTPFormContainer from '../superadmin/SFTPFormContainer';
import { storeWithExpiration } from '../../utils/common';

export class MyAccount extends React.Component {
  static propTypes = {
    account: PropTypes.object.isRequired,
    dialog: PropTypes.object.isRequired,
    closeDialogAction: PropTypes.func.isRequired,
    openDialogAction: PropTypes.func.isRequired,
    sendResetPasswordEmailAction: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
  };

  toggleSFTPDialog = evt => {
    const { account } = this.props;
    evt.preventDefault();
    this.toggleDialog(account.id, 'sftpDialog');
  };

  toggleDialog = (accountId, id) => {
    const { dialog, openDialogAction, closeDialogAction } = this.props;
    if (dialog.show && dialog.id === 'sftpDialog') {
      closeDialogAction(id);
    } else {
      openDialogAction(id, accountId);
    }
  };

  cancelDialog = id => {
    const { closeDialogAction } = this.props;
    closeDialogAction(id);
  };

  performSendResetPasswordEmail = evt => {
    const { sendResetPasswordEmailAction, user } = this.props;
    evt.preventDefault();
    const token = storeWithExpiration.get('token');
    sendResetPasswordEmailAction(token, user.id);
  };

  renderSFTPDialog = () => {
    const { dialog, account } = this.props;

    const dialogContent = (
      <SFTPFormContainer accountId={account.id} admin={false} cancelFunction={this.cancelDialog} />
    );
    return (
      <DialogForm
        cancelFunction={this.cancelDialog}
        cancelText="Close"
        content={dialogContent}
        id="sftpDialog"
        show={dialog.show}
        title="Modify SFTP Credentials: "
      />
    );
  };

  render() {
    const { dialog } = this.props;

    return (
      <div className="modal-wrap">
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <h1>My Account</h1>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <button type="button" className="btn btn-primary" onClick={this.toggleSFTPDialog}>
                Update SFTP Credentials
              </button>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={this.performSendResetPasswordEmail}
              >
                Reset Password
              </button>
            </div>
          </div>
        </div>
        {dialog.show && dialog.id === 'sftpDialog' ? this.renderSFTPDialog() : null}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { account, dialog, superadmin, user } = state;
  return { account, dialog, superadmin, user };
}

export default connect(mapStateToProps, {
  openDialogAction: openDialog,
  closeDialogAction: closeDialog,
  sendResetPasswordEmailAction: sendResetPasswordEmail,
})(MyAccount);
